/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshoptodos5Inputs */

const de__field_participatedulworkshoptodos5 = /** @type {(inputs: _Field_Participatedulworkshoptodos5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop ToDos`)
};

/**

* @param {_Field_Participatedulworkshoptodos5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshoptodos5 = /** @type {((inputs?: _Field_Participatedulworkshoptodos5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshoptodos5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshoptodos5(inputs)
});
export { _field_participatedulworkshoptodos5 as "_field_participatedULWorkshopToDos" }